import { useQuery } from '@tanstack/react-query'
import { dashboardQuery } from '~/pages/Dashboard'
import DemoBadge from '~/components/DemoBadge'
import Spinner from '~/components/Spinner'
import { rupees } from '~/lib/format'
import { Card, CardContent } from '~/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/components/ui/table'

export default function Courses() {
  const { data, isPending } = useQuery(dashboardQuery)

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Courses</h1>
          <p className="mt-1 text-sm text-ink-2">
            What the agent is selling, and how each course is converting.
          </p>
        </div>
        {data?.demo && <DemoBadge />}
      </div>

      <Card className="py-0">
        <CardContent className="px-0">
          {isPending ? (
            <div className="p-8">
              <Spinner />
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="px-5">Course</TableHead>
                  <TableHead className="px-5 text-right">Fee</TableHead>
                  <TableHead className="px-5 text-right">Conversations</TableHead>
                  <TableHead className="px-5 text-right">Converted</TableHead>
                  <TableHead className="px-5 text-right">Rate</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.courses.map((course) => (
                  <TableRow key={course.name}>
                    <TableCell className="px-5 py-3 font-medium">{course.name}</TableCell>
                    <TableCell className="px-5 py-3 text-right [font-variant-numeric:tabular-nums]">
                      {rupees(course.fee)}
                    </TableCell>
                    <TableCell className="px-5 py-3 text-right [font-variant-numeric:tabular-nums]">
                      {course.conversations}
                    </TableCell>
                    <TableCell className="px-5 py-3 text-right [font-variant-numeric:tabular-nums]">
                      {course.converted}
                    </TableCell>
                    <TableCell className="px-5 py-3 text-right [font-variant-numeric:tabular-nums]">
                      {course.conversion_rate}%
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
